import { BRAND_INTERNATIONAL, OFFICIAL_SLOGAN, STORE_NAME_UA } from "../brand.js";

export const messagesRu = {
  brand: {
    name: STORE_NAME_UA,
    international: BRAND_INTERNATIONAL,
    tagline: OFFICIAL_SLOGAN,
    slogan: OFFICIAL_SLOGAN,
  },
  nav: {
    home: "Главная",
    catalog: "Каталог",
    cart: "Корзина",
    profile: "Профиль",
  },
  common: {
    retry: "Повторить",
    loadMore: "Загрузить ещё",
    back: "Назад",
    close: "Закрыть",
    searchPlaceholder: "Поиск товаров…",
    noImage: "Без фото",
    customerFallback: "Гость",
    currency: "₴",
    soon: "Скоро",
  },
  session: {
    connecting: "Подключение сессии…",
    unavailable: "Не удалось открыть сессию",
    errorTitle: "Что-то пошло не так",
    telegramOnly: "Откройте приложение в Telegram для авторизации.",
  },
  home: {
    greeting: (name: string) => `Добро пожаловать, ${name}`,
    heroTitle: OFFICIAL_SLOGAN,
    heroSubtitle: "Выбирайте любимые вкусы Азии и заказывайте с доставкой Новой Почтой.",
    heroCta: "Смотреть каталог",
    categoriesTitle: "Категории",
    popularTitle: "Популярные товары",
    newTitle: "Новинки",
    promoTitle: "Акции",
    recommendedTitle: "Рекомендуем к заказу",
    cartShortcut: "Перейти в корзину",
    browseCatalog: "Открыть каталог",
    emptyCatalogHint: "Каталог обновляется. Попробуйте позже или напишите менеджеру.",
    categoriesLoading: "Загрузка категорий…",
    categoriesEmpty: "Категории появятся после синхронизации товаров.",
  },
  catalog: {
    title: "Каталог",
    sortLabel: "Сортировка",
    filterLabel: "Фильтр",
    sortDefault: "По умолчанию",
    sortPriceAsc: "Цена: по возрастанию",
    sortPriceDesc: "Цена: по убыванию",
    sortName: "По названию",
    allCategories: "Все категории",
    loading: "Загрузка каталога…",
    openingProduct: "Открываем товар…",
    addToCart: "Добавить в корзину",
    adding: "Добавляем…",
    added: "Добавлено в корзину",
    inStock: "В наличии",
    outOfStock: "Нет в наличии",
    emptyTitle: "Каталог пуст",
    emptySearchTitle: "Ничего не найдено",
    emptyFilterTitle: "Нет товаров по этому фильтру",
    emptyCategoryTitle: "В этой категории пока нет товаров",
    emptyBody: "Сейчас нет активных товаров с ценой.",
    emptySearchBody: "Попробуйте другой запрос или сбросьте фильтры.",
    emptyFilterBody: "Каталог не пуст — сбросьте фильтр или выберите другую категорию.",
    emptyCategoryBody: "В этой категории сейчас нет товаров с ценой. Выберите другую или сбросьте фильтр.",
    resetFilters: "Сбросить фильтры",
    showMoreCategories: "Ещё",
    loadMoreFailed: "Не удалось загрузить ещё",
    catalogFailed: "Не удалось загрузить каталог",
  },
  product: {
    backToCatalog: "← К каталогу",
    brand: "Бренд",
    category: "Категория",
    country: "Страна",
    weightOrVolume: "Вес / объём",
    stock: "Наличие",
    quantity: "Количество",
    relatedTitle: "С этим покупают",
    stickyAdd: "Добавить в корзину",
  },
  cart: {
    title: "Корзина",
    itemsCount: (count: number) => `${count} поз.`,
    loading: "Загрузка корзины…",
    emptyTitle: "Корзина пуста",
    emptyBody: "Добавьте товары из каталога — оформление займёт несколько минут.",
    emptyCta: "Перейти в каталог",
    clear: "Очистить корзину",
    checkout: "Оформить заказ",
    checkoutUnavailable: "Оформление временно недоступно",
    remove: "Удалить",
    unitPrice: (price: string) => `${price} / шт.`,
    subtotal: "Промежуточный итог",
    discount: "Скидка",
    total: "Итого",
    priceUpdatedTitle: "Цены обновлены",
    priceUpdatedBody: "Актуальные цены применены к корзине перед оформлением.",
    stagingNote: "",
    promoTitle: "Промокод",
    promoHint: "TG50: −50 ₴ от суммы от 500 ₴, один раз. Не суммируется с другими акциями.",
    promoPlaceholder: "TG50",
    promoApply: "Применить",
    promoRemove: "Снять",
    promoUnknown: "Неизвестный промокод",
    promoTg50Applied: (uah: number) => `TG50 применено: −${uah} ₴`,
    promoTg50UnderMin: (min: number) => `TG50: нужна сумма от ${min} ₴ — скидка ещё не активна`,
    promoAppliedOk: "Промокод принят",
    promoApplyFailed: "Не удалось применить промокод",
  },
  checkout: {
    title: "Оформление",
    backToCart: "← В корзину",
    summary: "Ваш заказ",
    contact: "Контактные данные",
    delivery: "Доставка",
    payment: "Оплата",
    fullName: "ФИО *",
    phone: "Телефон *",
    method: "Способ *",
    city: "Город *",
    warehouse: "Отделение / почтомат *",
    address: "Адрес *",
    comment: "Комментарий",
    loading: "Подготовка оформления…",
    emptyCart: "Корзина пуста. Добавьте товары перед оформлением.",
    browseCatalog: "Перейти в каталог",
    unavailable: "Корзина недоступна",
    submit: "Подтвердить заказ",
    submitting: "Отправляем…",
    confirmPriceChanges: "Подтвердить обновлённые цены",
    priceChangeTitle: "Цены изменились",
    priceChangeBody: "Подтвердите актуальные цены перед отправкой заказа.",
    paymentNote:
      "Онлайн-оплата сейчас выключена. После заказа статус будет «ожидаем оплату» — менеджер подтвердит оплату вручную. Ссылка эквайринга не создаётся.",
    npNote:
      "Новая Почта: выберите город и отделение или почтомат для доставки.",
    tg50Note:
      "Промокод TG50: −50 ₴ от суммы от 500 ₴, один раз на клиента, не суммируется с другими акциями. Подтверждает система/менеджер.",
    stagingBetaBanner: "",
    deliveryOptions: {
      nova_poshta_warehouse: "Новая Почта — отделение",
      nova_poshta_courier: "Новая Почта — курьер",
      pickup: "Самовывоз",
      other: "Другое",
    },
    paymentOptions: {
      cod: "Оплата при получении (согласование с менеджером)",
      prepaid: "Предоплата (ручное подтверждение)",
      novapay: "Онлайн-оплата картой",
      manager: "Согласовать оплату с менеджером",
    },
    successTitle: "Заказ принят",
    successBody:
      "Статус: ожидаем оплату (вручную). Онлайн-эквайринг и live ТТН Новой Почты выключены. Менеджер свяжется для подтверждения.",
    successOrderRef: (id: string) => `Номер заказа: ${id}`,
    successTaskRef: (id: string) => `Задача менеджера: ${id}`,
    orderNumberLabel: "Номер заказа",
    managerTaskLabel: "Задача менеджера",
    backToCatalog: "Вернуться в каталог",
  },
  profile: {
    title: "Профиль",
    phone: "Телефон",
    phoneMissing: "Не указан",
    segment: "Сегмент",
    orders: "Мои заказы",
    ordersPlaceholder: "История заказов появится здесь скоро.",
    favorites: "Избранное",
    favoritesSoon: "Скоро",
    recentlyViewed: "Недавно просмотренные",
    recentlyViewedSoon: "Скоро",
    repeatPurchase: "Повторить заказ",
    repeatPurchaseSoon: "Скоро",
    deliveryAddresses: "Адреса доставки",
    deliveryAddressesSoon: "Скоро",
    loyalty: "Бонусы и лояльность",
    loyaltySoon: "Скоро",
    support: "Написать в поддержку",
    supportHint: "Менеджер поможет с заказом и доставкой.",
    buildIdLabel: "Build ID",
  },
  segment: {
    new: "Новый",
    active: "Активный",
    vip: "VIP",
    at_risk: "Требует внимания",
    churned: "Неактивный",
  },
} as const;
